import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index',
    }, {
        path: '/index',
        name: 'homePage',
        component: () => import(/*webpackChunkName: "homePage"*/'../views/homePage/index'),
        meta: {title: '图模空间-工程数据智能管理平台-图纸识别-图模联动-智能图档-智能叠图-图模比对-智能问答-华阳城科', keepAlive: false},
    }, {
        path: '/tempFile',
        name:'tempFile',
    } ,{
        path: '/mine',
        name:'mine',
        redirect: '/file/1',
        component: () => import(/*webpackChunkName: "mine"*/'../views/mine/mine.vue'),
        meta: {title: 'IBIM个人业务'},
        children: [{
            path: '/file/:id',
            name: 'file',
            component: () => import(/*webpackChunkName: "file"*/'../views/mine/page/file.vue'),
            meta: {title: '文件目录', keepAlive: false},
        }, {
            path: '/recentlyViewe',
            name: 'recentlyViewe',
            component: () => import(/*webpackChunkName: "recentlyViewe"*/'../views/sidebarPage/recentlyViewe/index'),
            meta: {title: '最近浏览', keepAlive: false},
        }, {
            path: '/fileDynamics',
            name: 'fileDynamics',
            component: () => import(/*webpackChunkName: "fileDynamics"*/'../views/sidebarPage/fileDynamics/index'),
            meta: {title: '文件动态', keepAlive: false},
        }, {
            path: '/myCollect',
            name: 'myCollect',
            component: () => import(/*webpackChunkName: "myCollect"*/'../views/sidebarPage/myCollect/index'),
            meta: {title: '我的收藏', keepAlive: false},
        }, {
            path: '/home',
            name: 'home',
            component: () => import(/*webpackChunkName: "creativeFactory"*/'../views/CreativeFactory/index'),
            meta: {title: '首页', keepAlive: false},
        }, {
            path: '/dmAssociation',
            name: 'dmAssociation',
            component: () => import(/*webpackChunkName: "dmAssociation"*/'../views/sidebarPage/dmAssociation/index'),
            meta: {title: '图模关联', keepAlive: false},
        }, {
            path: '/markManage',
            name: 'markManage',
            component: () => import(/*webpackChunkName: "markManage"*/'../views/sidebarPage/markManage/index'),
            meta: {title: '批注管理', keepAlive: false},
        }, {
            path: '/dustbin',
            name: 'dustbin',
            component: () => import(/*webpackChunkName: "dustbin"*/'../views/sidebarPage/dustbin/index'),
            meta: {title: '回收站', keepAlive: false},
        }, {
            path: '/laboratory/:id',
            name: 'laboratory',
            component: () => import(/*webpackChunkName: "dustbin"*/'../views/mine/page/file.vue'),
            meta: {title: '图模实验室', keepAlive: false},
        }]
    },{
        path: '/FAQ',
        name: 'FAQ',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/BuildingAI/index'),
        meta: {
            title: '建筑问答'
        }
    },
    {
        path: '/note',
        name: 'note',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/NoteboolAI/index'),
        meta: {
            title: 'Noteboolm 问答'
        }
    },
    {
        path: '/cost',
        name: 'cost',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/CreativeFactory/answer'),
        meta: {
            title: '造价估算'
        }
    },{
        path: '/AIBus',
        name: 'AIBus',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/CreativeFactory/answer'),
        meta: {
            title: 'AI直通车'
        }
    },
    {
        path: '/entry',
        name: 'entry',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/entry/entry.vue'),
        meta: {
            title: '图模空间'
        }
    }, {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import(/*webpackChunkName: "dustbin"*/'../views/personalCenter/personalCenter'),
        meta: {title: '个人中心', keepAlive: false},
    },
    {
        path: '/403',
        name: '403',
        component: () => import(/* webpackChunkName: "403" */ '../views/Error/403'),
        meta: {
            title: '403'
        }
    },
    {
        path: '/404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '../views/Error/404'),
        meta: {
            title: '404'
        }
    },
    {
        path: '*',
        redirect: '/404'
    },
    {
        path: '/mb-pdf',
        name: 'mb-pdf',
        component: () => import(/* webpackChunkName: "404" */ '../views/BuildingAI/components/mb-pdf'),
        meta: {
            title: '源文件预览'
        }
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
